"use strict";

export default function () {
    const hamburguer = document.querySelector(".hamburguer-menu");
    const hiddenScroll = document.querySelector("body");
    const menu = document.querySelector(".menu-mobile");
    const close = menu.querySelector(".close-icon");
    const btn_contact = menu.querySelector(".button");
    hamburguer.addEventListener("click", () => {
        menu.classList.toggle("active");
        hiddenScroll.style.overflow = menu.classList.contains("active")
            ? "hidden"
            : "auto";
    });
    close.addEventListener("click", () => {
        menu.classList.toggle("active");
        hiddenScroll.style.overflow = menu.classList.contains("active")
            ? "hidden"
            : "auto";
    });
    btn_contact.addEventListener("click", () => {
        menu.classList.toggle("active");
        hiddenScroll.style.overflow = menu.classList.contains("active")
            ? "hidden"
            : "auto";
    });
    const anchorLinks = menu.querySelectorAll('a[href*="#"]');
    anchorLinks.forEach((anchor) => {
        anchor.addEventListener("click", () => {
            menu.classList.remove("active");
            hiddenScroll.style.overflow = "auto";
        });
    });
}
